module.exports = __webpack_public_path__ + "img/git.290b403d.svg";